import { render } from "./PlaMpStatusSelect.vue?vue&type=template&id=23842fb5"
import script from "./PlaMpStatusSelect.vue?vue&type=script&lang=js"
export * from "./PlaMpStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__